import { useMemo, useEffect } from 'react'
import { useTour, useReactTour } from '../../../context/tourProvider'
import { useFeatureIsOn } from '@growthbook/growthbook-react'
import { useTranslation } from '../../../context/translationProvider'

const CASINO_TOUR_STORAGE_KEY = 'casinoTourShown'

const InGameTour = () => {
  const tourLocation = 'in_game'
  const isCasinoTourEnabled = useFeatureIsOn('fe_casino_ingame_tour')
  const { translate, lang } = useTranslation()
  const { setIsOpen } = useReactTour()

  const tourSteps = useMemo(() => [
    {
      highlightedSelectors: ['#ingame-exit-button', '#ingame-deposit-button', '#ingame-cashback-button'],
      title: translate('game.onboardingTutorial.step1.subHeading'),
      content: translate('game.onboardingTutorial.step1.paragraph'),
      hideBackButton: true,
    },
    {
      selector: '#ingame-deposit-button',
      title: translate('game.onboardingTutorial.step2.subHeading'),
      content: translate('game.onboardingTutorial.step2.paragraph'),
      hideBackButton: true,
    },
    {
      selector: '#ingame-cashback-button',
      title: translate('game.onboardingTutorial.step3.subHeading'),
      content: translate('game.onboardingTutorial.step3.paragraph'),
      hideBackButton: true,
    },
  ], [translate, lang])

  useTour({
    storageKey: CASINO_TOUR_STORAGE_KEY,
    steps: tourSteps,
    enabled: isCasinoTourEnabled && !!lang,
    location: tourLocation,
  })

  useEffect(() => {
    return () => {
      setIsOpen(false)
    }
  }, [setIsOpen])

  return null
}

export { InGameTour } 